import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconRefresh({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="m3.523 6.392.44-.524c.176-.211.49-.24.702-.06l.384.321a.501.501 0 0 1 .062.703l-1.93 2.3a.501.501 0 0 1-.702.062l-2.3-1.93a.498.498 0 0 1-.061-.703l.322-.384a.501.501 0 0 1 .703-.062l.372.312a5 5 0 1 1 5.405 4.555c-.043.012-.926.018-.926.018a.498.498 0 0 1-.497-.505v-.99c0-.279.222-.505.505-.505h.527a3 3 0 1 0-3.006-2.608z"/>
        </svg>
    );
}

export default IconRefresh;
